import React from "react";
import NotSubscribed from "./NotSubscribed";
import { connect } from "react-redux";
import ScheduleAppointment from "./ScheduleAppointment";
import PhiNotFilled from "./PhiNotFilled";
import SubscribeNotTaken from "./SubscribeNotTaken";
import api from "../../utils/api";
import "./Appointment.scss";
import { CONSTANTS } from "utils/constant";
import { setTimeZoneOffset } from "store/slice/login-slice"; 
import Icons from "Common/Icons";
class Appointment extends React.Component {
  _baseClassName = "schedule-appointment-container";
  constructor(props) {
    super(props);
    this.state = {
      user_details: this.props.user_details,
      slotData: [],
      slot_details: [],
      flag: false,
      subscription : {},
      selectedView : '',
      is_evaluated : "",
      current_offset_date_time: ""
    };
  }

  getAppointmentView() {
    api
    .get_patient_status()
    .then((response) => {    
      let result = "appointment"  
      if(response.data?.data){
        response.data.data =  {...response.data.data, ...response.data.data.phi , ...response.data.data.time_zone,
          //  ...response.data.data.assessment.stress,
          // ...response.data.data.assessment.emotion,...response.data.data.assessment.geriatric,
           ...response.data.data.membership}
      }
      let { is_evaluated='',is_appointment_eligible = '', is_membership_active = '', is_membership_expired = '', membership_expiry_date  , membership_type='', is_socio_demographic = '' , is_care_team_ticket_created ='', is_membership_benefits_availed= '', membership_benefits_availed_date ='', display_plan_name= "" } = response.data?.data || {};

      localStorage.setItem("subscription", JSON.stringify({ is_evaluated,is_appointment_eligible, is_membership_active, is_membership_expired, membership_expiry_date, membership_type, is_socio_demographic, is_membership_benefits_availed, membership_benefits_availed_date, display_plan_name }))
      this.props.setTimeZoneOffset(response.data?.data?.time_zone_offset_in_min);
      if(is_membership_expired || (membership_type == "" && !is_appointment_eligible) || !is_membership_active || !membership_expiry_date){ result = "subscription"}
      // else if(!is_socio_demographic){ result =  "socio" }
      else if(membership_type && !is_appointment_eligible) result =  "notCompleted";
      // else if(is_care_team_ticket_created)
      //   result="careTeamAssigned"
      this.setState({ selectedView: result,
        is_evaluated :  is_evaluated,
        membership_type :  display_plan_name,
        current_offset_date_time: response.data?.data?.current_offset_date_time})
  })
}
       
  
  componentDidMount() {
    this.getAppointmentView();
  }
  render() {
    // this.getAppointmentView();
    return (
      <div className="appointment-wrapper">
        <div className="main-content">
          {/* <div className={`main-content-header`}>{`${CONSTANTS.SCHEDULE_YOUR_APPOINTMENT}`}</div> */}
            {(this.state.selectedView == "subscription" || this.state.selectedView == "notCompleted") && <NotSubscribed is_evaluated={this.state.is_evaluated} membership_type={this.state.membership_type} show={this.state.selectedView == "notCompleted" ? true : false}/> || null}
            {this.state.selectedView == "appointment" && <ScheduleAppointment history={this.props.history} currentOffsetDateTime={this.state.current_offset_date_time}/> || null}
            {this.state.selectedView == "nonsubscripe" && <SubscribeNotTaken data={this.state.user_details}/> || null}
            {/* {this.state.selectedView == "careTeamAssigned" && 
            <div className="main-content">
              <div className="phi-not-filled-content">
              <div><img className="center-img" src={Icons.info_blue}/></div>
                <div className="center-text care-team-is-assigned">{CONSTANTS.APPOINTMENT_CENTER_TEXT}</div>
              </div>
            </div>}
            {this.state.selectedView == "socio" && <PhiNotFilled data={this.state.user_details}/> || null} */}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user_details: state.loginReducer.user_details
  }
}
const mapDispatchToProps = {setTimeZoneOffset};
export default connect(mapStateToProps, mapDispatchToProps)(Appointment)